import React from 'react';
import { Colors } from 'library';
import { Text, Icon } from 'library/ui';
import { Step, StepIcon, StepLabel, Stepper, styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { differenceInMinutes } from 'date-fns';
import { ShiftProvider } from 'models';

export function BusinessSlotRecruitmentStatus({ addedAt, provider }: { addedAt: string; provider?: ShiftProvider }) {
    const minutesSincePosted = differenceInMinutes(new Date(), new Date(addedAt)) ?? 0;
    const recruitmentStatuses = [
        { title: 'Shift Posted', show: !provider && minutesSincePosted < 5 },
        {
            title: 'Finding Coverage',
            show: !provider && minutesSincePosted > 5,
        },
        { title: 'Worker Booked', show: !!provider },
    ];
    const activeRecruitmentStatusIndex = minutesSincePosted < 5 ? 0 : minutesSincePosted > 5 && !provider ? 1 : 2;

    return (
        <Stepper style={{ marginTop: 20 }} activeStep={activeRecruitmentStatusIndex} alternativeLabel>
            {recruitmentStatuses.map((step) => (
                <Step key={step.title}>
                    <StepLabel
                        StepIconComponent={({ active, completed, ...props }) => (
                            <StepIcon
                                {...props}
                                active={active}
                                completed={completed}
                                icon={
                                    active || completed ? (
                                        <Icon
                                            icon={CheckIcon}
                                            size="xs"
                                            iconColor={Colors.white}
                                            bgColor={Colors.secondary}
                                        />
                                    ) : (
                                        <Unfilled />
                                    )
                                }
                            />
                        )}
                    >
                        <Text size="xs">{step.title.toUpperCase()}</Text>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}

const Unfilled = styled('div')({
    width: 23,
    height: 23,
    borderRadius: '50%',
    backgroundColor: Colors.white,
    border: `1px dashed ${Colors.border}`,
});
